import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery } from 'gatsby'
import { graphql } from 'gatsby'

import MousseCSS from './section-mousse.module.css'

const FingerMousse = ({ fullpageApi }) => (
  <StaticQuery
    query={graphql`
      query ImageOneMousse {
        file(
          relativePath: { eq: "projets/Labo/finger/photos/finger-mousse.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 2240, quality: 87) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={({ file }) => (
      <div
        className="section"
        onClick={() => fullpageApi.moveSectionDown()}
        onKeyDown={() => fullpageApi.moveSectionDown()}
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer' }}
      >
        <Img
          className={MousseCSS.image}
          imgStyle={{ objectPosition: 'center right', objectFit: 'contain' }}
          fluid={file.childImageSharp.fluid}
        />
      </div>
    )}
  />
)

export default FingerMousse
